// Ignore stale SEO resolution while navigating between keyword URLs.
export const klaviyoRouteTarget = (route: any, resolved: any = {}) => {
  const path = route.path || "";
  const legacy = path.match(/^\/store\/(product|category)\/([^/]+)/);
  if (legacy)
    return { type: legacy[1], id: String(route.params?.id || legacy[2]) };
  if (
    resolved.path === path &&
    !resolved.notFound &&
    resolved.id &&
    (resolved.type === "product" || resolved.type === "category")
  ) {
    return { type: resolved.type, id: String(resolved.id) };
  }
  return { type: "", id: "" };
};
